import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import Table from './table';
import { useDateRange } from '@spa/shared/hooks/dateRange';
import { useMedia } from '@spa/shared/hooks/media';
import { CalendarIcon, ArrowIcon } from '@spa/shared/svg';
import { Input, InputContainer, Container, Arrow } from './styles';

export const defaultMinimumDayGap = 27;
export const barcelonaMinimumDayGap = 32;

export const DateRange = ({
  start,
  end,
  startName,
  endName,
  startLabel,
  endLabel,
  isBarcelona = false,
  onChange,
  shouldOpenDatesFilter = false,
  closeDatesFilter = () => {}
}) => {
  const { is } = useMedia();
  const ref = useRef();
  const dateRange = useDateRange(
    ref,
    start,
    end,
    startName,
    endName,
    onChange,
    isBarcelona ? barcelonaMinimumDayGap : defaultMinimumDayGap
  );
  const {
    startDate,
    choosingStart,
    choosingEnd,
    startDateLabel,
    isFocused,
    focus: focusContainer,
    focusStart: focusMoveIn,
    endDateLabel
  } = dateRange;

  useEffect(() => {
    if (!isFocused) {
      closeDatesFilter();
    }

    if (shouldOpenDatesFilter) {
      if (is.notMobile) {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      focusContainer();
      focusMoveIn();
    }
  }, [isFocused, shouldOpenDatesFilter]);

  return (
    <Container ref={ref}>
      <InputContainer>
        <CalendarIcon />
        <Input
          value={startDateLabel}
          type="text"
          className="first"
          readOnly
          placeholder={startDateLabel || startLabel}
        />
        <Arrow className={!choosingStart && !shouldOpenDatesFilter && 'down'}>
          <ArrowIcon />
        </Arrow>
      </InputContainer>
      <InputContainer className={!startDate && 'disabled'}>
        <CalendarIcon />
        <Input type="text" value={endDateLabel} className="last" readOnly placeholder={endDateLabel || endLabel} />
        <Arrow className={!choosingEnd && 'down'}>
          <ArrowIcon />
        </Arrow>
      </InputContainer>
      {isFocused || shouldOpenDatesFilter ? <Table dateRange={dateRange} /> : null}
    </Container>
  );
};

DateRange.propTypes = {
  start: PropTypes.string,
  end: PropTypes.string,
  startName: PropTypes.string.isRequired,
  startLabel: PropTypes.string.isRequired,
  endName: PropTypes.string.isRequired,
  endLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isBarcelona: PropTypes.bool,
  shouldOpenDatesFilter: PropTypes.bool,
  closeDatesFilter: PropTypes.func
};

export default DateRange;
